var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenOrientation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5417 10.4167C82.2917 16.6667 91.875 30 93.5417 45.8333H99.7917C97.2917 20 76.0417 0 49.7917 0C48.9583 0 48.125 0 46.875 0L62.7083 15.8333L68.5417 10.4167ZM42.2917 7.08333C39.7917 4.58333 36.0417 4.58333 33.5417 7.08333L6.87501 33.75C4.37501 36.25 4.37501 40 6.87501 42.5L56.875 92.5C59.3752 95.0002 63.125 95.0002 65.6252 92.5L92.2917 65.8333C94.7918 63.3332 94.7918 59.5833 92.2917 57.0832L42.2917 7.08333ZM61.4583 88.3333L11.4583 38.3333L38.125 11.6667L88.125 61.6667L61.4583 88.3333ZM31.0417 89.5833C17.2917 83.3333 7.70834 70 6.04168 54.1667H0.208344C2.29168 80 23.5417 100 49.7917 100C50.625 100 51.4583 100 52.7083 100L36.8752 84.1667L31.0417 89.5833Z",
    fill: "#F16161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenOrientation);
export default __webpack_public_path__ + "static/media/screenOrientation.6967ad3b8c2c05a5306fd59e9dcaa8c4.svg";
export { ForwardRef as ReactComponent };